export const FontLoader = () => {
   const style = document.createElement("style");
   style.innerHTML = `
     @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;700&display=swap');
   `;

   document.head.appendChild(style);

   return null;
 };
